module.exports = __webpack_public_path__ + "img/报警事件.075a0276.png";